export const MAIL_URL = "https://www.campingbelage.com/mailer/";
export const API_URL = "https://www.campingbelage.com/api";
export const MY_MAIL_URL = "https://www.campingbelage.com/mymailer/";


